import { defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';

var CHECKBOX_SIZES = {
  REGULAR: 'regular',
  SMALL: 'small'
};
var CHECKBOX_DIMENSIONS = _defineProperty(_defineProperty({}, CHECKBOX_SIZES.REGULAR, '1.5rem'), CHECKBOX_SIZES.SMALL, '1rem');
var CHECKBOX_ICON_SIZES = _defineProperty(_defineProperty({}, CHECKBOX_SIZES.REGULAR, '1.125rem'), CHECKBOX_SIZES.SMALL, '0.75rem');

export { CHECKBOX_DIMENSIONS, CHECKBOX_ICON_SIZES, CHECKBOX_SIZES };
//# sourceMappingURL=Checkbox.constants.js.map
